import axios from "axios";
import * as actionType from "../../../constant/actionType";

export const PayClientInvoice = (payload) => async (dispatch) => {
  try {
    const storedData = JSON.parse(localStorage.getItem("LoginUserData"));
    const response = await axios({
      method: "post",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
        organisationid: storedData?.organisation_id,
      },
      url: `${actionType.environment_url}/api/client/PayClientInvoice`,
      data: payload,
    });
    return response.data;
  } catch (error) {
    return error?.response?.data || { success: false, message: error.message };
  }
};
